import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    canceled: "Cancelado",
    today: "Hoy",
    free: "Gratis",
    sponsored: "Patrocinado",
    seePrice: "Ver precio",
    // Monto ya formateado con la moneda del país del evento (formatMoney).
    from: (price: string) => `Desde ${price}`,
    online: "Online",
    details: "Ver detalle →",
  },
  en: {
    canceled: "Canceled",
    today: "Today",
    free: "Free",
    sponsored: "Sponsored",
    seePrice: "See price",
    from: (price: string) => `From ${price}`,
    online: "Online",
    details: "View details →",
  },
});
